import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-cream min-h-[90vh] flex items-center py-16 px-4 md:px-8 overflow-hidden" data-id="element-69">
      <div className="max-w-6xl mx-auto w-full" data-id="element-70">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-71">
          {/* Copy Column */}
          <div className="order-2 lg:order-1 space-y-8" data-id="element-72">
            <FadeIn data-id="element-73">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-navy-800 leading-tight mb-4" data-id="element-74">
                Stop Ripping Off Your CPAP at 2 AM
              </h1>
              <p className="text-xl md:text-2xl text-teal-600 font-medium font-serif italic mb-8" data-id="element-75">
                A calm, step-by-step plan to get through the first 30 nights
                without quitting.
              </p>
            </FadeIn>

            <FadeIn delay={200} data-id="element-76">
              <div className="space-y-6 text-lg-body text-text-body leading-relaxed" data-id="element-77">
                <p data-id="element-78">
                  If you've ever woken up at 2:07 AM with your CPAP mask half
                  on, air hissing into your eyes, mouth dry like sandpaper… and
                  your hand already reaching to rip the whole thing off—
                </p>
                <p className="font-semibold text-navy-800" data-id="element-79">
                  You're not "bad at CPAP."
                </p>
                <p data-id="element-80">
                  You're sleeping in an unstable setup… and your brain is doing
                  the one thing it's designed to do at night: remove the threat.
                </p>
                <p data-id="element-81">
                  The reason you're stuck isn't because you haven't tried hard
                  enough. It's because the advice you're getting is backwards.
                </p>
                <div className="pl-4 border-l-4 border-teal-600 italic text-gray-600 my-6" data-id="element-82">
                  "Try another mask."
                  <br data-id="element-83" />
                  "You'll get used to it."
                  <br data-id="element-84" />
                  "Just tighten it."
                </div>
                <p data-id="element-85">
                  That advice turns your first month into a nightly experiment
                  with your sleep as the price.
                </p>
                <p className="font-medium text-navy-800" data-id="element-86">
                  CPAP Compliance Rescue is a calm, step-by-step plan built
                  specifically for men 65+ to get through the first 30 nights
                  without quitting—by fixing the few predictable problems in the
                  only order that works.
                </p>
              </div>
            </FadeIn>

            <FadeIn delay={400} data-id="element-87">
              <div className="pt-4" data-id="element-88">
                <a href="#pricing" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-amber-500 rounded-lg hover:bg-amber-600 transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200" data-id="element-89">
                  Get the 30-Night Stabilization Ladder
                  <ArrowRight className="ml-2 h-5 w-5" data-id="element-90" />
                </a>
                <p className="mt-3 text-sm text-gray-500" data-id="element-91">
                  Instant digital download • Secure checkout
                </p>
              </div>
            </FadeIn>
          </div>

          {/* Image Column */}
          <div className="order-1 lg:order-2 relative" data-id="element-92">
            <FadeIn delay={300} data-id="element-93">
              <div className="relative rounded-xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-94">
                <img src="https://cdn.magicpatterns.com/uploads/ikNs4K7zcgG2UnTB7zFUdY/heylloyd-image-1770960574266.png" alt="CPAP Compliance Rescue Guide on Tablet" className="w-full h-auto object-cover" data-id="element-95" />
              </div>
              {/* Decorative element */}
              <div className="absolute -z-10 top-10 -right-10 w-full h-full bg-blue-50 rounded-xl transform rotate-3" data-id="element-96"></div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}